/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const I={INITIALIZING:0,CONSTRUCTING:1,CONSTRUCTED:2,DESTROYING:3,DESTROYED:4};export{I as Lifecycle};
